import { render, staticRenderFns } from "./yxaccount_tx.vue?vue&type=template&id=f38fc450&scoped=true&"
import script from "./yxaccount_tx.vue?vue&type=script&lang=js&"
export * from "./yxaccount_tx.vue?vue&type=script&lang=js&"
import style0 from "./yxaccount_tx.vue?vue&type=style&index=0&id=f38fc450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38fc450",
  null
  
)

export default component.exports